import {
  CreateGalleryFromScratchBody,
  CreateGalleryPresetBody,
  GalleryDto,
  GalleryPresetDto,
  UpdateGalleryBodyDto,
} from '@picflow/types';
import { StandardGalleryPreset } from '../configs/standard-presets';
import { copy } from './copy';

export const GetSubGalleryFields = (template: GalleryDto): CreateGalleryFromScratchBody => {
  const gallery: CreateGalleryFromScratchBody = {
    password_enabled: template.password_enabled,
    show_in_profile: template.show_in_profile,
    password: template['password'] || undefined,
    title: '',
    enabled_feedback_options: template.enabled_feedback_options,
    enabled_gallery_statuses: template.enabled_gallery_statuses,
    // public_access: template.public_access, default value is null
    // tenant_access: template.tenant_access, default value is null
    approval_limits: template.approval_limits,
    requires_user_identification: template.requires_user_identification,
    color_mode: template.color_mode,
    contacts_hidden: template.contacts_hidden,
    save_camera_metadata: template.save_camera_metadata,
    email_notifications: template.email_notifications,
    download_media_size: template.download_media_size,
    download_full_gallery: template.download_full_gallery,
    download_single_asset: template.download_single_asset,
    approved_downloads_only: template.approved_downloads_only || undefined,
    color_labels: template.color_labels,
    primary_color: template.primary_color,
    client_advanced_mode_enabled: template.client_advanced_mode_enabled,
    version_history_enabled: template.version_history_enabled,
    enabled_asset_statuses: template.enabled_asset_statuses,
    cover: {
      overlay_color: 'rgba(31,35,46,0.2)',
      position: '50% 50%',
      size: 'medium',
      uuid: '',
    },
  };

  return gallery;
};

export const getPresetChanges = (preset: GalleryPresetDto | StandardGalleryPreset) => {
  const changes: UpdateGalleryBodyDto = {};
  changes.enabled_feedback_options = preset.enabled_feedback_options;
  changes.enabled_gallery_statuses = preset.enabled_gallery_statuses;
  changes.approval_limits = preset.approval_limits;
  changes.save_camera_metadata = preset.save_camera_metadata;
  changes.download_media_size = preset.download_media_size;
  changes.download_full_gallery = preset.download_full_gallery;
  changes.download_single_asset = preset.download_single_asset;
  changes.approved_downloads_only = preset.approved_downloads_only;
  changes.requires_user_identification = preset.requires_user_identification;
  changes.client_advanced_mode_enabled = preset.client_advanced_mode_enabled;
  changes.version_history_enabled = preset.version_history_enabled;
  changes.color_labels = preset.color_labels;
  changes.watermark = <string>preset.watermark;
  changes.default_title_typography = copy(preset.default_title_typography);
  changes.default_paragraph_typography = copy(preset.default_paragraph_typography);
  changes.layout_background_color = preset.layout_background_color;
  changes.enabled_asset_statuses = preset.enabled_asset_statuses;
  return changes;
};

export const galleryToPreset = (gallery: GalleryDto): CreateGalleryPresetBody => {
  return {
    enabled_feedback_options: gallery.enabled_feedback_options,
    enabled_gallery_statuses: gallery.enabled_gallery_statuses,
    approval_limits: gallery.approval_limits,
    save_camera_metadata: gallery.save_camera_metadata,
    download_media_size: gallery.download_media_size,
    download_full_gallery: gallery.download_full_gallery,
    download_single_asset: gallery.download_single_asset,
    approved_downloads_only: gallery.approved_downloads_only,
    requires_user_identification: gallery.requires_user_identification,
    client_advanced_mode_enabled: gallery.client_advanced_mode_enabled,
    version_history_enabled: gallery.version_history_enabled,
    color_labels: gallery.color_labels,
    watermark: <string>gallery.watermark,
    default_title_typography: copy(gallery.default_title_typography),
    default_paragraph_typography: copy(gallery.default_paragraph_typography),
    layout_background_color: gallery.layout_background_color,
    enabled_asset_statuses: gallery.enabled_asset_statuses,
  };
};
